<template>
  <div class="start">
    <h3>Wähle deinen Level</h3>
    <div class="buttons">
      <button
        v-for="button in buttons"
        v-bind:key="button.level"
        @click="handleLevelButton(button.level)"
        class="levelButton"
        v-html="button.name" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      buttons: [
        { level: 1, name: '<span>🤷‍♂️</span> Anfänger' },
        { level: 2, name: '<span>🙆‍♀️</span> Globusdreher' },
        { level: 3, name: '<span>👩‍🎓</span> Streber' },
        { level: 4, name: '<span>👑</span> Geografieprofi' },
        { level: 5, name: '<span>👨‍🚀</span> Alleswisser' }
      ]
    }
  },
  methods: {
    handleLevelButton (level) {
      this.$gtag.event('select-level', {
        event_category: 'setup',
        event_label: level
      })
      this.$router.push({ name: 'play', params: { level } })
    }
  }
}
</script>

<style lang="postcss">
.start {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & .buttons {
    display: flex;
    flex-direction: column;
  }

  & .levelButton {
    font-size: 1rem;
    padding: 0.8rem;
    background-color: white;
    outline: none;
    border-radius: .5rem;
    margin-bottom: 1rem;
    cursor: pointer;

    & span {
      font-size: 2em;
      vertical-align: sub;
    }
  }
}
</style>
